import { render, staticRenderFns } from "./AssemblySelection.vue?vue&type=template&id=5cd1d602"
import script from "./AssemblySelection.vue?vue&type=script&lang=js"
export * from "./AssemblySelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports